export const generateUniqueDeviceId = () => {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 10) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString();
    });
};
